export function parseColor(input, opacity, multiplier = 1) {
  let cache;
  const p = parseInt; // Use p as a byte saving reference to parseInt
  const color = input.replace(/\s/g, ''); // Remove all spaces

  // Checks for 6 digit hex and converts string to integer
  if ((cache = /#([\da-fA-F]{2})([\da-fA-F]{2})([\da-fA-F]{2})/.exec(color)))
    cache = [p(cache[1], 16), p(cache[2], 16), p(cache[3], 16)];
  // Checks for 3 digit hex and converts string to integer
  else if ((cache = /#([\da-fA-F])([\da-fA-F])([\da-fA-F])/.exec(color)))
    cache = [p(cache[1], 16) * 17, p(cache[2], 16) * 17, p(cache[3], 16) * 17];
  // Checks for rgba and converts string to
  // integer/float using unary + operator to save bytes
  else if (
    (cache = /rgba\(([\d]+),([\d]+),([\d]+),([\d]+|[\d]*.[\d]+)\)/.exec(color))
  )
    cache = [+cache[1], +cache[2], +cache[3], +cache[4]];
  // Checks for rgb and converts string to
  // integer/float using unary + operator to save bytes
  else if ((cache = /rgb\(([\d]+),([\d]+),([\d]+)\)/.exec(color)))
    cache = [+cache[1], +cache[2], +cache[3]];
  // Otherwise throw an exception to make debugging easier
  else throw new Error(color + ' is not supported by $.parseColor');

  isNaN(opacity) || (cache[3] = opacity);

  // Performs RGBA conversion by default
  isNaN(cache[3]) && (cache[3] = 1);

  // Adds or removes 4th value based on rgba support
  // Support is flipped twice to prevent erros if
  // it's not defined
  return {
    r: cache[0] * multiplier,
    g: cache[1] * multiplier,
    b: cache[2] * multiplier,
    a: cache[3]
  };
}

export function rgbaString({ r, g, b, a }) {
  return `rgba(${r}, ${g}, ${b}, ${a})`;
}

export function factorColor(color, opacity = 1, multiplier = 1) {
  return rgbaString(parseColor(color, opacity, multiplier));
}
